import React from 'react';
import PropTypes from 'prop-types';
import { OUTCOME_TYPES } from 'Components/ComponentLibrary/Organisms/Outcome/outcomeTypes';
import PiggyBank from 'Icons/PiggyBank';
import { AirplanemodeActive, School, TrendingDown } from '@material-ui/icons';
import { FDIcon } from '@facet-wealth/design';

const FACET_DESIGN_ICON_TYPE = {
  [OUTCOME_TYPES.RETIREMENT]: 'beachAccess',
  [OUTCOME_TYPES.GENERAL_SAVINGS]: 'showChart',
};

const ICON_COMPONENTS_BY_TYPE = {
  [OUTCOME_TYPES.EMERGENCY_FUND]: PiggyBank,
  [OUTCOME_TYPES.PAY_OFF_DEBT]: TrendingDown,
  [OUTCOME_TYPES.EDUCATION]: School,
  [OUTCOME_TYPES.LIFESTYLE]: AirplanemodeActive,
};

export default function OutcomeIcon({ type }) {
  if (type in FACET_DESIGN_ICON_TYPE) {
    return <FDIcon color={'primary'} icon={FACET_DESIGN_ICON_TYPE[type]} />;
  }

  if (type in ICON_COMPONENTS_BY_TYPE) {
    const Component = ICON_COMPONENTS_BY_TYPE[type];
    return <Component color={'primary'} />;
  }

  return null;
}
OutcomeIcon.propTypes = {
  type: PropTypes.string.isRequired,
};
